var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9694 3.23219C10.943 2.64652 10.8484 2.2458 10.7142 1.89572C10.5733 1.53463 10.3863 1.22638 10.0805 0.922538C9.77459 0.618695 9.46873 0.427142 9.10786 0.288431C8.75799 0.151922 8.35751 0.0594476 7.77219 0.0330264C7.18467 0.00660528 6.99763 0 5.50574 0C4.01164 0 3.8246 0.00660528 3.23928 0.0330264C2.65397 0.0594476 2.25349 0.154123 1.90362 0.288431C1.54054 0.429343 1.23248 0.616493 0.92882 0.922538C0.62516 1.22858 0.433721 1.53463 0.295094 1.89572C0.160867 2.2458 0.0662478 2.64652 0.0398425 3.23219C0.0134373 3.82006 0.00683594 4.00721 0.00683594 5.5C0.00683594 6.995 0.0134373 7.18215 0.0398425 7.76781C0.0662478 8.35348 0.160867 8.7542 0.295094 9.10428C0.435922 9.46537 0.622959 9.77362 0.92882 10.0775C1.23248 10.3835 1.54054 10.5729 1.90141 10.7116C2.25128 10.8481 2.65177 10.9406 3.23708 10.967C3.8246 10.9934 4.01164 11 5.50354 11C6.99763 11 7.18467 10.9934 7.76999 10.967C8.35531 10.9406 8.75579 10.8459 9.10566 10.7116C9.46653 10.5707 9.77459 10.3835 10.0783 10.0775C10.3819 9.77142 10.5733 9.46537 10.712 9.10428C10.8484 8.7542 10.9408 8.35348 10.9672 7.76781C10.9936 7.17994 11.0002 6.99279 11.0002 5.5C11.0002 4.00721 10.9958 3.81785 10.9694 3.23219ZM9.98143 7.72378C9.95723 8.26101 9.86701 8.55384 9.79219 8.7454C9.69317 9.0008 9.57215 9.18575 9.37851 9.3795C9.18487 9.57326 9.00224 9.68995 8.74478 9.79344C8.55115 9.86829 8.25849 9.95857 7.72378 9.98279C7.14506 10.0092 6.97123 10.0158 5.50133 10.0158C4.03144 10.0158 3.85761 10.0092 3.27889 9.98279C2.74198 9.95857 2.44932 9.86829 2.25789 9.79344C2.00264 9.69436 1.8178 9.57326 1.62416 9.3795C1.43052 9.18575 1.3139 9.003 1.21048 8.7454C1.13566 8.55164 1.04544 8.25881 1.02124 7.72378C0.994834 7.14472 0.988232 6.97078 0.988232 5.5C0.988232 4.02922 0.994834 3.85528 1.02124 3.27622C1.04544 2.73899 1.13566 2.44616 1.21048 2.2546C1.3095 1.9992 1.43052 1.81425 1.62416 1.6205C1.8178 1.42674 2.00043 1.31005 2.25789 1.20657C2.45152 1.13171 2.74418 1.04143 3.27889 1.01721C3.85761 0.990793 4.03144 0.984187 5.50133 0.984187C6.97123 0.984187 7.14506 0.990793 7.72378 1.01721C8.26069 1.04143 8.55335 1.13171 8.74478 1.20657C9.00004 1.30564 9.18487 1.42674 9.37851 1.6205C9.57215 1.81425 9.68877 1.997 9.79219 2.2546C9.86701 2.44836 9.95723 2.74119 9.98143 3.27622C10.0078 3.85528 10.0144 4.02922 10.0144 5.5C10.0144 6.97078 10.0056 7.14472 9.98143 7.72378Z",
    fill: "url(#paint0_linear_2033_20578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50115 2.67297C3.93883 2.67297 2.67578 3.93899 2.67578 5.50004C2.67578 7.06329 3.94103 8.3271 5.50115 8.3271C7.06126 8.3271 8.32651 7.05888 8.32651 5.50004C8.32651 3.93678 7.06346 2.67297 5.50115 2.67297ZM5.50115 7.3341C4.48894 7.3341 3.66818 6.51285 3.66818 5.50004C3.66818 4.48723 4.48894 3.66597 5.50115 3.66597C6.51335 3.66597 7.33411 4.48723 7.33411 5.50004C7.33411 6.51285 6.51335 7.3341 5.50115 7.3341Z",
    fill: "url(#paint1_linear_2033_20578)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4365 3.2234C8.80108 3.2234 9.09663 2.92767 9.09663 2.56287C9.09663 2.19807 8.80108 1.90234 8.4365 1.90234C8.07192 1.90234 7.77637 2.19807 7.77637 2.56287C7.77637 2.92767 8.07192 3.2234 8.4365 3.2234Z",
    fill: "#BC30A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5C0 6.995 0.00660132 7.18215 0.0330066 7.76781C0.0594119 8.35348 0.154031 8.7542 0.288258 9.10428C0.429086 9.46537 0.616123 9.77362 0.921984 10.0775C1.22565 10.3813 1.53371 10.5729 1.89458 10.7116C2.24445 10.8481 2.64493 10.9406 3.23025 10.967C3.81776 10.9934 4.0048 11 5.4967 11C6.9908 11 7.17784 10.9934 7.76315 10.967C8.34847 10.9406 8.74895 10.8459 9.09882 10.7116C9.45969 10.5707 9.76775 10.3835 10.0714 10.0775C10.3751 9.77362 10.5665 9.46537 10.7051 9.10428C10.8416 8.7542 10.934 8.35348 10.9604 7.76781C10.9868 7.17994 10.9934 6.99279 10.9934 5.5C10.9934 4.005 10.9868 3.81785 10.9604 3.23219C10.934 2.64652 10.8394 2.2458 10.7051 1.89572C10.5643 1.53463 10.3773 1.22638 10.0714 0.922538C9.76995 0.616493 9.46189 0.427142 9.10102 0.288431C8.75115 0.151922 8.35067 0.0594476 7.76535 0.0330264C7.17784 0.00660528 6.9908 0 5.4989 0C4.0048 0 3.81776 0.00660528 3.23245 0.0330264C2.64713 0.0594476 2.24665 0.154123 1.89678 0.288431C1.53591 0.429343 1.22785 0.616493 0.924185 0.922538C0.620524 1.22858 0.429086 1.53463 0.290458 1.89572C0.154031 2.2458 0.0594119 2.64652 0.0330066 3.23219C0.00660132 3.81785 0 4.005 0 5.5ZM0.992398 5.5C0.992398 4.03143 0.999 3.85528 1.02541 3.27622C1.04961 2.73899 1.13983 2.44616 1.21464 2.2546C1.31366 1.9992 1.43469 1.81425 1.62833 1.6205C1.82196 1.42674 2.0046 1.31005 2.26205 1.20657C2.45569 1.13171 2.74835 1.04143 3.28306 1.01721C3.86177 0.990793 4.03561 0.984187 5.5055 0.984187C6.9754 0.984187 7.14923 0.990793 7.72795 1.01721C8.26485 1.04143 8.55751 1.13171 8.74895 1.20657C9.0042 1.30564 9.18904 1.42674 9.38268 1.6205C9.57631 1.81425 9.69294 1.997 9.79636 2.2546C9.87117 2.44836 9.96139 2.74119 9.9856 3.27622C10.012 3.85528 10.0186 4.02922 10.0186 5.5C10.0186 6.97078 10.012 7.14472 9.9856 7.72378C9.96139 8.26101 9.87117 8.55384 9.79636 8.7454C9.69734 9.0008 9.57631 9.18575 9.38268 9.3795C9.18904 9.57326 9.0064 9.68995 8.74895 9.79344C8.55531 9.86829 8.26265 9.95857 7.72795 9.98279C7.14923 10.0092 6.9754 10.0158 5.5055 10.0158C4.03561 10.0158 3.86177 10.0092 3.28306 9.98279C2.74615 9.95857 2.45349 9.86829 2.26205 9.79344C2.0068 9.69436 1.82196 9.57326 1.62833 9.3795C1.43469 9.18575 1.31806 9.003 1.21464 8.7454C1.13983 8.55164 1.04961 8.25881 1.02541 7.72378C0.996799 7.14472 0.992398 6.96858 0.992398 5.5Z",
    fill: "url(#paint2_linear_2033_20578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2033_20578",
    x1: 9.30233,
    y1: 0.841135,
    x2: 1.34454,
    y2: 10.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468721,
    stopColor: "#B23BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#BD368E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    stopColor: "#CE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#E62335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#FF1800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2033_20578",
    x1: 6.84858,
    y1: 3.2326,
    x2: 3.9577,
    y2: 8.09026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12F6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    stopColor: "#EA3751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    stopColor: "#F13D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#F64133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#F7422F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7946,
    stopColor: "#F74C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#F7652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9757,
    stopColor: "#F78F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79A2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2033_20578",
    x1: 7.99246,
    y1: -0.452848,
    x2: 3.12303,
    y2: 11.1541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#9E35A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4512,
    stopColor: "#D42F7F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7524,
    stopColor: "#F7772E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9624,
    stopColor: "#FEF780"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.0d2e275ec78fee33b7c6816466849b0f.svg";
export { ForwardRef as ReactComponent };